// extracted by mini-css-extract-plugin
export default {"activeDeals":"ActiveDeals_activeDeals__nzb3Q","header":"ActiveDeals_header__wj3+S","deals":"ActiveDeals_deals__wJ9nk","dealItem":"ActiveDeals_dealItem__ILQKG"};